function randomIntFromInterval(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

const CACHE_BUST = randomIntFromInterval(0, 9e5);

export const MOBILE_WIDTH = 768;

export const mapboxStyleURL =
  "mapbox://styles/propublica/cmesu6ycz00sw01r91o4jfg5k";

// // stripped basemap for promo image
// export const mapboxStyleURL =
//   "mapbox://styles/propublica/cmhmeaqe9009c01qia1lahkxr";

export const mapboxToken =
  "pk.eyJ1IjoicHJvcHVibGljYSIsImEiOiJjaWt6dzNnNjQxbHBudTlrc3Nqc3NidG5qIn0.ChQFj8IDuUNxSg_I6_3Pnw";

export const farmsDataURL = `https://propublica.s3.amazonaws.com/projects/graphics/2025-bird-flu/map/farms-in-study-zone.geojson?${CACHE_BUST}`;

export const otherFarmsDataURL = `https://propublica.s3.amazonaws.com/projects/graphics/2025-bird-flu/map/farms-outside-study-zone.geojson?${CACHE_BUST}`;

export const stateShapesURL =
  "https://propublica.s3.amazonaws.com/projects/graphics/2025-bird-flu/map/ohio-indiana-states.geojson";

export const plumeDataURL =
  "https://propublica.s3.amazonaws.com/projects/graphics/2025-bird-flu/map/wind.geojson";
